// Log a Return FORM loader (GW-471) — lazy-loads the direct-mount widget bundle.
//
// GW builds a dedicated storefront CORE page (its own header/footer) and drops:
//     <div data-pf-log-return-form></div>
// …optionally pre-selecting an order and/or setting where Cancel/View-returns go:
//     <div data-pf-log-return-form data-order="SPMJK8HB" data-returns-url="/returns-history"></div>
//
// We do NOT iframe the SPA: the storefront sends `X-Frame-Options: deny`, so no
// frame renders. Instead — exactly like the b2b app's `data-gw-widget` — the form
// is a self-contained React IIFE (public/js/log-return-widget.js, CSS inlined)
// that mounts DIRECTLY into the div. This tiny storefront.js widget just injects
// that bundle (once, and only on pages that actually have the marker, so the heavy
// React bundle never loads elsewhere) after publishing the app base URL + API key
// the bundle's api client reads.
import { getTopDocument } from '../shared/dom.js';
import { getAppBaseUrl, getApiKey } from '../shared/config.js';

export var id = 'log-return-form';

var WIDGET_FLAG = '__pfLogReturnWidgetInjected';

export function init() {
  var doc = getTopDocument();
  var markers = doc.querySelectorAll('[data-pf-log-return-form]');
  if (!markers || markers.length === 0) return;

  var win = doc.defaultView || window;

  // Publish config the widget's SPA api client resolves from (client.ts reads
  // these globals first): app base URL for '/api' + the machine key fallback.
  // API base is same-origin here anyway, but set it explicitly so resolution is
  // deterministic on a plain CORE page (no parts-finder-embed.js present).
  try {
    if (!win.__PARTS_FINDER_APP_BASE_URL__) win.__PARTS_FINDER_APP_BASE_URL__ = getAppBaseUrl();
    if (!win.__PARTS_FINDER_API_KEY__) win.__PARTS_FINDER_API_KEY__ = getApiKey();
  } catch (e) { /* non-fatal */ }

  // Already loaded (e.g. two markers on one page, or a re-init) → just re-scan.
  if (win[WIDGET_FLAG]) {
    try { if (win.PartsFinderLogReturn && win.PartsFinderLogReturn.autoMount) win.PartsFinderLogReturn.autoMount(); } catch (e) { /* ignore */ }
    return;
  }
  win[WIDGET_FLAG] = true;

  var src = getAppBaseUrl() + 'js/log-return-widget.js';
  var s = doc.createElement('script');
  s.src = src;
  s.async = true;
  s.onload = function () {
    // The bundle auto-mounts on load, but call again in case the markers were
    // added after it evaluated. Idempotent (guarded by a WeakSet in the bundle).
    try { if (win.PartsFinderLogReturn && win.PartsFinderLogReturn.autoMount) win.PartsFinderLogReturn.autoMount(); } catch (e) { /* ignore */ }
  };
  s.onerror = function () {
    win[WIDGET_FLAG] = false; // allow a retry on a later init
    try { console.error('[parts-finder] failed to load log-return widget bundle from ' + src); } catch (e) { /* ignore */ }
  };
  (doc.head || doc.getElementsByTagName('head')[0] || doc.body).appendChild(s);
}
